export default __webpack_public_path__ + "static/media/top-right.6f3da90c.png";